"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = _interopRequireDefault(require("../styles"));

var _tokens = require("../styles/tokens");

var _classnames = _interopRequireDefault(require("classnames"));

var colorBackgroundHeaderUtilityBar = '#3939B8';
var colorBackgroundHeaderUtilityBarThemed = _tokens.colorBrandNeutral200;

var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      height: "" + _tokens.sizingXxLarge1,
      borderBottom: _tokens.spacing20 + " solid " + theme.palette.secondary.main,
      backgroundColor: colorBackgroundHeaderUtilityBar,
      '&.themed': {
        backgroundColor: colorBackgroundHeaderUtilityBarThemed
      }
    }
  };
};
/**
 * The utility area of a `HeaderBar`.
 *
 * @done true
 * @updated false
 * @versionAdded v0.2.4
 */


var HeaderUtilityBar = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2.default)(HeaderUtilityBar, _React$Component);

  function HeaderUtilityBar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = HeaderUtilityBar.prototype;

  _proto.renderChildren = function renderChildren() {
    var _this = this;

    var children = [];

    if (this.props.SearchItem) {
      children.push(this.props.SearchItem);
    }

    children.push(_react.default.Children.map(this.props.children, function (child) {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        isUtility: true,
        responsiveType: child.props.responsiveType || _this.props.responsiveType
      });
    }));
    return children;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        classes = _this$props.classes,
        className = _this$props.className,
        isThemed = _this$props.isThemed;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(classes.root, className, {
        'themed': isThemed
      })
    }, this.renderChildren());
  };

  return HeaderUtilityBar;
}(_react.default.Component);

HeaderUtilityBar.propTypes = {
  /**
   * At what breakpoint to hide all utility items on the header bar.
   *
   * Valid values are:
   *
   * - `none` - Never hide anything
   * - `small` - Hide items at the small breakpoint (and above)
   * - `medium` - Hide items at the medium breakpoint (and above)
   * - `large` - Hide items at the large breakpoint (and above)
   */
  responsiveType: _propTypes.default.string,

  /**
   * The items in the utility bar. Only accepts `HeaderBarItem`s.
   */
  children: function children(props, propName, componentName) {
    var error;
    var prop = props[propName];

    _react.default.Children.forEach(prop, function (child) {
      if (child.type.displayName.indexOf('HeaderBarItem') === -1) {
        error = new Error(componentName + " only accepts children of type HeaderBarItem");
      }
    });

    return error;
  },

  /** @ignore */
  isThemed: _propTypes.default.bool,

  /** @ignore */
  SearchItem: _propTypes.default.node,

  /** @ignore */
  classes: _propTypes.default.object.isRequired,

  /** @ignore */
  className: _propTypes.default.string
};
HeaderUtilityBar.defaultProps = {
  isThemed: false
};

var _default = (0, _styles.default)(styles)(HeaderUtilityBar);

exports.default = _default;